<template>
<div>
    <div id="downloadapp" v-show="htmlShow">
        <img class="download-bg" src="@/assets/download_bg.png" alt="">
        <img id="btn_download" @click="downloadBtn" src="@/assets/btn_download.png" alt="">
        <img id="btn_close" @click="cloxeBtn" src="@/assets/btn_close.png" alt="">
    </div>
    <!-- <div id="downloadapp" v-show="miniShow">
        <img class="download-bg" src="@/assets/minidownload.png" alt="">
        <img id="btn_close" @click="cloxeBtn" src="@/assets/btn_close.png" alt="">
    </div> -->
</div>
  
</template>

<script>
export default {
    name: 'download',
    data () {
        return {
           htmlShow: false,
           miniShow: false
        }
    },
    props: [
       'introduce' 
    ],
    mounted () {
        this.ismimi()
        console.log(sessionStorage.getItem('downloadshow'))
        if (this.isAndroid() == null && sessionStorage.getItem('downloadshow') == null) {
            this.closedownload()
            this.miniShow = false
        }
        if(this.ismimi() !== null && sessionStorage.getItem('downloadshow') == null){
            this.miniShow = true
            this.htmlShow = false
        }
    },
    methods: {
            isAndroid() {
                let userAgent = navigator.userAgent;
                return userAgent.match(/app_szxc/);
            },
            ismimi(){
                let userAgent = navigator.userAgent;
                // let userAgent = 'Mozilla/5.0 (Linux; Android 9; ELE-AL00 Build/HUAWEIELE-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/67.0.3396.87 XWEB/1166 MMWEBSDK/191201 Mobile Safari/537.36 MMWEBID/8156 MicroMessenger/7.0.10.1580(0x27000A5D) Process/appbrand3 NetType/WIFI Language/zh_CN ABI/arm64 miniProgram'
                //  console.log(userAgent)
                let isminiapp= userAgent.match(/miniProgram/);
                // console.log(isminiapp)
                return isminiapp
            },
            closedownload() {
                this.htmlShow = true
            },
            downloadBtn() {
                window.location.href = '//a.app.qq.com/o/simple.jsp?pkgname=com.lbcy.house_info'
            },
            cloxeBtn() {
                sessionStorage.setItem('downloadshow', 'false')
                this.htmlShow = false
                this.miniShow = false
            }
    },
    watch: {
      
    }
}
</script>

<style lang="scss" scoped>
        #downloadapp {
            position: fixed;
            bottom: -6px;
            left: 0;
            right: 0;
            // display: none;
            z-index: 100;
        }
        
        .download-bg {
            width: 100%;
        }
        
        #btn_download {
            position: absolute;
            width: 15%;
            right: 55px;
            top: 50%;
            transform: translate(0, -50%);
        }
        
        #btn_close {
            position: absolute;
            width: 4%;
            right: 20px;
            margin-left: 40px;
            top: 50%;
            transform: translate(0, -50%);
        }
</style>